
import { NSpin } from 'naive-ui';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';

import ComponentBase from '~/components/component-base';


import { useStationDetailStore } from '~/store/station-details.store';
import MeasureDatatable from '~/components/measures-datatable/measure-datatable.vue';

export default defineComponent({

    extends: ComponentBase,

    components: {
        MeasureDatatable,
        NSpin,
    },

    computed: {
         ...mapState(useStationDetailStore, ['station', 'measures', 'since', 'before']),
    }
});